var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenalty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Soccerball_shade 2",
    clipPath: "url(#clip0_3_6565)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3702",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3131 23.3019C23.3131 23.6828 18.7847 23.9917 13.1987 23.9917C7.61261 23.9917 3.08423 23.6828 3.08423 23.3019C3.08423 22.9209 7.61261 22.612 13.1987 22.612C18.7847 22.612 23.3131 22.9209 23.3131 23.3019Z",
    fill: "black",
    fillOpacity: 0.179487
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4591",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2749 23.2709C20.2749 23.4977 17.315 23.6817 13.6637 23.6817C10.0124 23.6817 7.05249 23.4977 7.05249 23.2709C7.05249 23.044 10.0124 22.86 13.6637 22.86C17.315 22.86 20.2749 23.044 20.2749 23.2709Z",
    fill: "black",
    fillOpacity: 0.179487
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4593",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.639 23.2876C21.639 23.5976 17.9573 23.8489 13.4157 23.8489C8.87409 23.8489 5.19238 23.5976 5.19238 23.2876C5.19238 22.9776 8.87409 22.7263 13.4157 22.7263C17.9573 22.7263 21.639 22.9776 21.639 23.2876Z",
    fill: "black",
    fillOpacity: 0.179487
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2916",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3751 12.2542C23.3751 18.4053 18.3887 23.3917 12.2376 23.3917C6.08652 23.3917 1.1001 18.4053 1.1001 12.2542C1.1001 6.10311 6.08652 1.11668 12.2376 1.11668C18.3887 1.11668 23.3751 6.10311 23.3751 12.2542Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1918",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3751 12.2542C23.3751 18.4053 18.3887 23.3917 12.2376 23.3917C6.08652 23.3917 1.1001 18.4053 1.1001 12.2542C1.1001 6.10311 6.08652 1.11668 12.2376 1.11668C18.3887 1.11668 23.3751 6.10311 23.3751 12.2542Z",
    fill: "url(#paint0_radial_3_6565)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_6565",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 23,
    height: 23
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2918",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3751 12.4042C23.3751 15.358 22.2017 18.1909 20.113 20.2796C18.0243 22.3683 15.1914 23.5417 12.2376 23.5417C9.28375 23.5417 6.45088 22.3683 4.3622 20.2796C2.27351 18.1909 1.1001 15.358 1.1001 12.4042C1.1001 9.45034 2.27351 6.61748 4.3622 4.52879C6.45088 2.4401 9.28375 1.26669 12.2376 1.26669C15.1914 1.26669 18.0243 2.4401 20.113 4.52879C22.2017 6.61748 23.3751 9.45034 23.3751 12.4042Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_6565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path623",
    d: "M22.877 8.71557C22.5474 8.20224 22.2294 7.96518 21.6018 7.80734",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1939",
    d: "M4.25024 3.91982L5.26274 4.95107",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1941",
    d: "M4.10014 7.4167C1.80087 9.06341 1.24076 12.4046 1.32514 12.3855",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1943",
    d: "M7.02513 7.66045C6.78803 9.41073 7.41899 11.329 8.73138 13.3792",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    d: "M2.68457 16.0323C3.76657 17.1141 5.20473 16.948 6.55645 16.9792",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    d: "M9.84722 20.3811C9.61305 21 9.67358 21.8574 9.80744 22.7742",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1949",
    d: "M8.22974 2.64819C9.09051 1.78635 10.9369 1.23011 13.3474 0.977646",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1951",
    d: "M18.2994 4.27231C17.7004 3.15663 16.6451 2.27995 15.5283 1.43544",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1953",
    d: "M10.0991 4.57063C11.4223 4.71967 13.8107 4.91571 15.7074 5.98927",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1964",
    d: "M17.1876 9.8167C16.0534 11.3807 14.6843 12.8402 13.1001 14.2042",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1966",
    d: "M13.8127 18.3855C15.2646 19.1955 16.8548 19.5438 18.7815 19.2292",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1968",
    d: "M20.6377 10.7542C21.3788 12.1456 21.4875 14.1207 21.5939 16.0979",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1970",
    d: "M21.3313 7.77295C21.9417 7.79347 22.5333 8.11603 23.0938 8.93545",
    stroke: "black",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1972",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5188 7.86669C5.06785 8.13809 5.70527 8.02868 6.98755 8.14794C7.74556 7.15331 9.03223 5.89435 10.3813 4.60419C9.82452 3.73534 9.29901 2.84611 8.63755 2.29794C6.95828 2.86723 5.76241 3.56836 4.62505 4.28544C3.91118 5.5285 3.5327 6.72364 3.5188 7.86669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2860",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3501 5.82295C15.8596 7.22312 16.2977 8.48062 16.9438 10.1542C18.2733 10.5053 19.6908 10.9267 20.7876 11.0917C21.1402 10.3839 21.3734 9.01992 21.6313 7.7917C20.7553 6.43283 19.5058 5.26073 18.2376 4.09795C17.3049 4.43433 16.3323 5.09012 15.3501 5.82295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2862",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5063 13.0417C10.2159 13.3229 11.8653 13.6042 13.475 13.8854C13.9727 15.4479 14.0371 17.0104 14.2063 18.5729C12.9756 19.5956 11.2784 19.9186 9.7813 20.5417C8.03932 19.4157 7.33006 18.1606 6.3313 16.9417C6.90481 15.6228 7.53748 14.3112 8.5063 13.0417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2864",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.57959 11.677C0.582007 11.7556 1.1831 11.844 1.4016 11.7566C1.65258 13.3629 1.98125 14.9175 2.86001 16.1053C2.68796 16.947 2.84993 17.6218 3.09866 18.2531C1.57478 18.6802 1.70725 18.9112 1.10992 19.1812",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2866",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17456 21.8461C7.62286 22.2296 8.67796 22.9739 9.79406 22.5886C10.1223 23.0536 11.0305 23.3899 13.4003 23.4902L6.9568 24.0603",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2868",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9719 16.4636C22.5491 16.152 22.1117 15.855 21.5656 15.6667C20.4781 17.1155 19.3906 18.7648 18.3031 19.2854C18.2831 20.1786 18.1439 20.9765 17.75 21.5706C18.5713 21.626 19.4292 21.623 20.375 21.4792",
    fill: "black"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path2923",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3751 12.2542C23.3751 18.4053 18.3887 23.3917 12.2376 23.3917C6.08652 23.3917 1.1001 18.4053 1.1001 12.2542C1.1001 6.10311 6.08652 1.11668 12.2376 1.11668C18.3887 1.11668 23.3751 6.10311 23.3751 12.2542Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_6565",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.51735 8.09992) scale(28.7579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000022",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000022",
    stopOpacity: 0.39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_6565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5 0.666687)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenalty);
export default __webpack_public_path__ + "static/media/penalty.841132344c75c4956c033a88c3b6edd8.svg";
export { ForwardRef as ReactComponent };